/**
 * Whether a control's declared default is empty text, which a board reads as
 * no default: a field control's field value `""`, or a value control's
 * tagged value `{ type: "string", value: "" }` (`withoutEmptyTextDefaults`).
 * It takes any value, so a chat confirmation card can test a default the
 * model wrote before the board parses it.
 */
export function isEmptyText(value: unknown): boolean {
  if (value === "") {
    return true;
  }
  return (
    typeof value === "object" &&
    value !== null &&
    "type" in value &&
    value.type === "string" &&
    "value" in value &&
    value.value === ""
  );
}
